import { useBadgingTranslation } from '../../../../ui/hooks';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColorsDark } from '@juvare/common-web-ui/JuvareTheme/colors/themeColorsDark';
import { Button, DialogActions, DialogContent, DialogTitle, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { useIsOverflow } from '../hooks/useIsOverflow';
export const ShowMoreText = ({ title, description }) => {
    const { t } = useBadgingTranslation();
    const descriptionRef = React.useRef(null);
    const isOverflow = useIsOverflow({ ref: descriptionRef });
    const handleMoreClick = () => {
        showCustomDialog({
            content: (close, ariaTitleId, ariaContentId) => (React.createElement(React.Fragment, null,
                React.createElement(DialogTitle, { id: ariaTitleId }, title),
                React.createElement(DialogContent, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, id: ariaContentId },
                    React.createElement(Typography, { variant: 'body2', sx: { width: '100%' } }, description)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => close() }, t('badges.badgeCard.close'))))),
        });
    };
    return (React.createElement(Stack, { direction: 'row', sx: { minWidth: 0 }, gap: 1 },
        React.createElement(Typography, { variant: 'body2', color: themeColorsDark.text.subtle, noWrap: true, ref: descriptionRef }, description),
        isOverflow && (React.createElement(Link, { variant: 'body2', fontWeight: 700, color: themeColorsDark.text.link, onClick: handleMoreClick, sx: { cursor: 'pointer' } }, t('common.more')))));
};
